export default __webpack_public_path__ + "static/serving0-66dca1135ae42e94cb4f0e8c5674f7b0.jpg";